'use strict'
// 判断是男是女
exports.sexIs = (value) => { //
  if (value == 0 || value == '0') {
    var newDate = '男'
    return newDate
  } else if (value == 1 || value == '1') {
    var newDate = '女'
    return newDate
  } else {
    var newDate = ''
    return newDate
  }
}
//判断医生主主页评价，将姓之后的文字以*代替
exports.regRealname=(text)=>{
		if(text.length==1){
			return text;
		}else if(text.length==2){
			return text.substring(0,1)+"*"
		}else if(text.length>2){
			return text.substring(0,1)+"**"+text.substring(text.length-1,text.length)
		}
}

//判断就诊人姓名 超过4个省略
exports.peopleName = (text,len)=>{
	let lens=len?len:4
	if (!text || text.length <= lens) {
    return text ;
  } else {
    return text.substring(0,lens)+"..."
  }
}

//判断就诊人姓名 超过3个省略
exports.refpeopleName=(text)=>{
		if(!text || text.length<=3){
			return text;
		}else{
			return text.substring(0,2)+"..."
		}
}
//判断如果购买服务页面的价格是1次，直接转换为空
exports.regAir=(val)=>{
  // return val==0||val==1 ? null : val
  return val==0 ? null : val
}
// 地址省份判断
exports.provinceLimit = (str) => {
  let spstr = str.split('')
  spstr[spstr.length - 1]
  return spstr[spstr.length - 1] == '市' ? '' : str
}

// 阿拉伯数字转中文---------------------
let chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
let chnUnitSection = ['', '万', '亿', '万亿', '亿亿']
let chnUnitChar = ['', '十', '百', '千']
let numToChn = function (num) {
  let index = num.toString().indexOf('.')
  if (index != -1) {
    let str = num.toString().slice(index)
    let a = '点'
    for (let i = 1; i < str.length; i++) {
      a += chnNumChar[parseInt(str[i])]
    }
    return a
  } else {
    return ''
  }
}

// 定义在每个小节的内部进行转化的方法，其他部分则与小节内部转化方法相同
function sectionToChinese (section) {
  var str = '',
    chnstr = '',
    zero = false,
    count = 0 // zero为是否进行补零， 第一次进行取余由于为个位数，默认不补零
  while (section > 0) {
    var v = section % 10 // 对数字取余10，得到的数即为个位数
    if (v == 0) { // 如果数字为零，则对字符串进行补零
      if (zero) {
        zero = false // 如果遇到连续多次取余都是0，那么只需补一个零即可
        chnstr = chnNumChar[v] + chnstr
      }
    } else {
      zero = true // 第一次取余之后，如果再次取余为零，则需要补零
      str = chnNumChar[v]
      str += chnUnitChar[count]
      chnstr = str + chnstr
    }
    count++
    section = Math.floor(section / 10)
  }
  return chnstr
}
exports.toChinese = (num) => {
  var a = numToChn(num)
  num = Math.floor(num)
  var unitPos = 0
  var strIns = '',
    chnStr = ''
  var needZero = false

  if (num === 0) {
    return chnNumChar[0]
  }
  while (num > 0) {
    var section = num % 10000
    if (needZero) {
      chnStr = chnNumChar[0] + chnStr
    }
    strIns = sectionToChinese(section)
    strIns += (section !== 0) ? chnUnitSection[unitPos] : chnUnitSection[0]
    chnStr = strIns + chnStr
    needZero = (section < 1000) && (section > 0)
    num = Math.floor(num / 10000)
    unitPos++
  }
  return chnStr + a
}
// 阿拉伯数字转中文---------------------

// 时间戳的/1000 的值 转为 年-月-日
exports.toTime = (val,type) => {
  let date;
  val.toString().length==10 ? date = new Date(val * 1000) : date = new Date(val)
  let y = date.getFullYear()
  let m = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
  let d = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate()
  let h = date.getHours() >= 10 ? date.getHours() : '0' + date.getHours()
  let M = date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes()
  let s = date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds()
  return type=='md' ? m + '-' + d : type=='Ms' ? M + ':' + s : y + '-' + m + '-' + d + ' ' + h + ':' + M + ':' + s
}
exports.toTime1 = (val,type) => {
  let date;
  val.toString().length==10 ? date = new Date(val * 1000) : date = new Date(val)
  let y = date.getFullYear()
  let m = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
  let d = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate()
  return type=='md' ? m + '/' + d : y + '/' + m + '/' + d
}
// 小写转大写数字  阿拉伯数字转中
exports.toChineseNum = (val) => {
  // debugger
  // console.log(val)
  var changeNum
  if(val=='包裹 0'){
    changeNum='包裹一'
    return changeNum
  }else if(val=='包裹 1'){
    changeNum='包裹二'
    return changeNum
  }else if(val=='包裹 2'){
    changeNum='包裹三'
    return changeNum
  }else if(val=='包裹 3'){
    changeNum='包裹四'
    return changeNum
  }else if(val=='包裹 4'){
    changeNum='包裹五'
    return changeNum
  }else if(val=='包裹 5'){
    changeNum='包裹六'
    return changeNum
  }else if(val=='包裹 6'){
    changeNum='包裹七'
    return changeNum
  }else{
    changeNum='包裹八'
    return changeNum
  }

}
// 保留两位小数
exports.tofixed = (value) => {
  value = Number(value)
  return value.toFixed(2)
}
// 判断大于零且保留两位小数(优惠券专用)
exports.yhTofixed = (value) => {
  var a = value >= 0 ? value : 0
  a = Number(a)
  return a.toFixed(2)
}
// 转空格
exports.tokg = (value) => {
  var arr = value.split('||')
  var html = ''
  for (var i = 0; i < arr.length; i++) {
    html += arr[i] + ' '
  }
  return html
}
//如果值为1则改成空字符串
exports.blankNum = (value) => {
  var arr = value
  if(arr==1){
    arr=''
  }
  return arr
}
// 支付方式payWay
exports.payWayVal = (value) => {
  if(value == 1){
    return "支付宝支付"
  }
  if(value == 0){
    return "优惠券支付"
  }
  if(value == 2){
    return "微信支付"
  }
  if(value == 3){
    return "微信、优惠券混合支付"
  }
  if(value == 4){
    return "微信APP支付"
  }
  if(value == 5){
    return "挂账支付"
  }
  if(value == 10){
    return "快递代收"
  }
  if(value == 11){
    return "定金预定"
  }
}
exports.replace = (text) =>{
  return text ? text.replace(/星期/, '周') :''
}

exports.todh = (val) =>{
  if (val) {
    return val.split(',').join('、')
  }
}
exports.hideid = (text) => {
  if(!text) return ''
  var a = text.substr(0,3)
  var b = text.substr(text.length - 4,text.length)
  var content = a + '***********' + b
  return content;
}
exports.limitTo= (val,length)=>{
  return val&&val.substring(0,length)
}



// WEBPACK FOOTER //
// ./src/filters/index.js